import {
  sendAnalyticsTrack,
  sendMraidAnalyticsTrack
} from '../../js/TrackAnalyticsHelper';
import { preventSpamCallsShared } from '../../js/utils';
import { AnalyticsStore } from '../AnalyticsStore';
import { MraidStore } from '../MraidStore';
import { DisplayConfigType } from '../../../formats/display/lib/config';
import { DebugLog } from '../../js/debug-log';

interface UserCloseHandlerProps {
  analyticsStore: AnalyticsStore;
  mraidStore: MraidStore;
  adContext: AdContext;
  formatName?: string;
  formatConfig: DisplayConfigType;
}

export class UserCloseHandler {
  analyticsStore: AnalyticsStore;
  mraidStore: MraidStore;
  adContext: AdContext;
  formatName: string;
  formatConfig: DisplayConfigType;

  constructor({
    mraidStore,
    analyticsStore,
    adContext,
    formatName = '',
    formatConfig
  }: UserCloseHandlerProps) {
    this.mraidStore = mraidStore;
    this.analyticsStore = analyticsStore;
    this.adContext = adContext;
    this.formatName = formatName;
    this.formatConfig = formatConfig;
    this.handle = preventSpamCallsShared(this.handle.bind(this));
  }

  shouldSendCloseCreativeTrack() {
    return (
      this.formatConfig.shouldSendCloseCreativeTrack &&
      ['overlay_thumbnail', 'header_ad', 'footer_ad', 'interstitial'].indexOf(
        this.adContext.adUnitType as string
      ) > -1
    );
  }

  handle(e: ClickEvent) {
    e.stopPropagation();
    sendAnalyticsTrack(e, 'close_button');
    if (this.shouldSendCloseCreativeTrack()) {
      this.analyticsStore.sendCreativeTrack('close_button_click');
    }
    this.mraidStore.close();
  }

  handleMraid() {
    // On header/footer/TN ad unit, the close button don't close the ad, so we can continue to click on the creative
    if (
      ['interstitial', 'medium_rectangle'].indexOf(
        this.adContext.adUnitType as string
      ) > -1
    ) {
      window.mraid.open = window.mraid.openNoRedirect = (url: string) => {
        DebugLog.log('format is closing, cannot open', { url });
      };
    }

    sendMraidAnalyticsTrack('close_button');
    if (this.shouldSendCloseCreativeTrack()) {
      this.analyticsStore.sendCreativeTrack('close_button_click');
    }

    this.mraidStore.close();
  }
}
